<template>
    <section class="p-2">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-6">
                    <h5 v-if="title">
                        <i :class="icon" v-if="icon"></i>
                        {{ title }}
                    </h5>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: null
        },
        icon : {
            type: String,
            default: null
        }
    },
    beforeMount() {
        let title = this.$store.state.app.name;
        title = this.title ? `${this.title} | ${title}` : title;
        document.title = title;
    }
}
</script>